import { render, staticRenderFns } from "./HistoryDialog.vue?vue&type=template&id=add8bd82&"
import script from "./HistoryDialog.vue?vue&type=script&lang=js&"
export * from "./HistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports